import {
  useWSModal,
  WSActions,
  WSDivider,
  WSForm,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import { Address } from "@wingspanhq/wingspan-api-sdk";
import * as Yup from "yup";
import { FormPartialAddress } from "../../../Onboarding/components/FormPartialAddress";
import { getValidationSchemaAddress } from "../../../../shared/validators/address/validationSchemaAddress";

export interface UpdateBillingAddressProps {
  address: Address | undefined;
  onSuccess: (address: Address) => void;
  onClose: () => void;
}

// `FormPartialAddress` and `getValidationSchemaAddress` are shared with ten
// other screens and stay keyed on `addressLine*`, so the v3 Address is mapped
// to and from those field names here rather than reshaping the shared form.
type AddressFormValues = {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postalCode: string;
};

const UpdateBillingAddress: React.FC<UpdateBillingAddressProps> = ({
  address,
  onClose,
  onSuccess
}) => {
  const country = address?.country || "US";
  const defaultValues: { address: AddressFormValues } = {
    address: {
      addressLine1: address?.line1 ?? "",
      addressLine2: address?.line2 ?? "",
      city: address?.city ?? "",
      state: address?.state ?? "",
      postalCode: address?.postalCode ?? ""
    }
  };

  return (
    <WSList gap="L">
      <WSInfoBox>
        Enter the address where you want your physical business debit card to be
        sent.
      </WSInfoBox>
      <WSForm
        defaultValues={defaultValues}
        validationSchema={Yup.object().shape({
          address: getValidationSchemaAddress(country)
        })}
        onSubmit={(formValues: { address: AddressFormValues }) => {
          onSuccess({
            line1: formValues.address.addressLine1,
            line2: formValues.address.addressLine2,
            city: formValues.address.city,
            state: formValues.address.state,
            postalCode: formValues.address.postalCode,
            country
          });
          onClose();
        }}
      >
        <WSList gap="XL">
          <FormPartialAddress country={country} name="address" />
          <WSDivider />
          <WSActions
            alignment="fill"
            buttons={[
              {
                label: "Save",
                type: "submit",
                kind: "Primary"
              },
              {
                label: "Cancel",
                onClick: onClose,
                kind: "Secondary"
              }
            ]}
          />
        </WSList>
      </WSForm>
    </WSList>
  );
};

export function useUpdateBillingAddressModal() {
  return useWSModal(UpdateBillingAddress, {
    title: "Edit address",
    size: "S"
  });
}
